import {
  _trim,
  _clone,
  _forin,
  _filterMapToArray,
  _applyOrdering,
} from '../utils';
import createLogger from '../../utils/createLogger';

const DEBUG = true;
const debug = createLogger(DEBUG, `owpSelectors.js`);

const owpJobsSelector = (state) => {
  let { owpJobs } = state.owp;
  return _applyOrdering(owpJobs);
};

const createOpenWebJobSelector = (id) => (state) => {
  return state.owp.owpJobs.records[id] || state.jobs.leads.records[id];
};

export {
  owpJobsSelector,
  createOpenWebJobSelector,
}


// WEBPACK FOOTER //
// ./src/data/owp/owpSelectors.js